import "./Charger.css";

const icons = [
  "Home/Apartment",
  "Hotels/Resorts",
  "Offices",
  "Open Parking",
  "Shops/Stores",
  "Cafes/Restaurants"
];

const ChargerUsageIcons = () => {
  return (
    <div className="usage-icons">
      {icons.map((item, index) => (
        <div key={index} className="icon">
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
};

export default ChargerUsageIcons;
